import { Component, OnInit, Input, Output, EventEmitter, TRANSLATIONS } from '@angular/core';
import { ShareModel } from '../../models/share.model';
import { LocalStoreManager } from '../../services/local-store-manager.service';
import { BreakpointObserver } from '@angular/cdk/layout';
import { ShareDataService } from '../../providers/sharedata.service';

import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { RestApiService } from 'src/services/rest-api.service';
import { DialogComponent } from '../dialog/dialog.component';
import { MatDialog } from '@angular/material';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
    @Input('title') title: string;
    @Input('url') url?: string;
    @Input('hasLogo') hasLogo: boolean;
    @Input('hasRefresh') hasRefresh: boolean;
    @Input('hasPager') hasPager: boolean;
    @Input('hasnotification') hasnotification: boolean;
    @Output() refresher: EventEmitter<any> = new EventEmitter();

    isToggledUppercase = false;
    hideComponents = false;
    hideGuides = false;
    hideCDK = false;
    selectedthem = 2;
    isToggleOpen = false;
    currenturl = '';
    hideNotification: boolean = false;
    sidemenuGarsonCall: boolean; headerGarsonCall: boolean;
    constructor(
        private breakObserver: BreakpointObserver,
        private storageManager: LocalStoreManager,
        public share: ShareDataService,
        protected router: Router,
        protected translate: TranslateService,
        protected api: RestApiService<any>,
        protected dialog: MatDialog
    ) {
        this.storageManager.initialiseStorageSyncListener();
        // this.spinner.stopAll();
    }
    ngOnInit() {
        this.sidemenuGarsonCall = this.checkNotification('sidemenu');
        this.headerGarsonCall = this.checkNotification();
        if (!(this.hasLogo)) {
            this.hasLogo = false;
        }
        if (!(this.hasRefresh)) {
            this.hasRefresh = false;
        }
        this.share.sharemodel = new ShareModel();
        this.share.sharemodel.language = this.storageManager.getData(
            'Language'
        );
        switch (this.storageManager.getData('Language')) {
            case 'FA': {
                this.translate.setDefaultLang('EN');
                this.translate.use('FA');
                this.share.sharemodel.isrtl = true;
                this.share.sharemodel.language = 'FA';

                break;
            }
            case 'EN': {
                this.translate.setDefaultLang('FA');
                this.translate.use('EN');
                this.share.sharemodel.isrtl = false;
                this.share.sharemodel.language = 'EN';

                break;
            }
            default: {
                this.translate.setDefaultLang('EN');
                this.translate.use('FA');
                this.share.sharemodel.isrtl = true;
                this.share.sharemodel.language = 'FA';

                break;
            }
        }
    }
    setLanguage(lan: string) {
        this.share.sharemodel.language = lan;
        // let defaultLanguage = this.translate.getDefaultLang();
        this.translate.setDefaultLang(lan);
        this.translate.use(lan);
        this.storageManager.savePermanentData(lan, 'Language');
        switch (lan) {
            case 'FA': {
                this.share.sharemodel.isrtl = true;
                break;
            }
            case 'EN': {
                this.share.sharemodel.isrtl = false;
                break;
            }
            default: {
                this.translate.setDefaultLang('FA');
                this.translate.use('FA');
                this.share.sharemodel.isrtl = true;
                break;
            }
        }
    }
    refresh() {
        this.share.getDigitalMenuCount();
        this.refresher.emit(this.url);
    }
    callWaiters() {
        this.confirmation(this.translate.instant('MainPage.GarsonCall'));
    }
    confirmation(title: string) {
        const dialogRef = this.dialog.open(DialogComponent);
        dialogRef.componentInstance.confirmation(title);
        dialogRef.afterClosed().subscribe(result => {
            if (result === 'Ok') {
                this.afterConfirm();
            } else {
                return;
            }
        });
    }
    afterConfirm() {
        this.api.getFilterEntity<any>('CallWaiters', this.share.digitalmenuTableId).subscribe((res: number) => {
            this.isToggleOpen = false;
        });
        this.isToggleOpen = false;
    }
    go(url: string) {
        this.isToggleOpen = !this.isToggleOpen;
        if (url === 'waiterorder') {
            if (this.share.setting.showTablesPage === 0) {
                url = 'table';
            } else {
                url = 'waiterorder';
            }
        }
        if (url === 'order/TableId/' && this.share.tableId && this.share.tableId != '')
            url = url + this.share.tableId
        if (url === 'order/TableId/' && (!this.share.tableId || this.share.tableId != '')) {
            this.share.tableId = '1';
            url = url + this.share.tableId;
        }
        this.share.lastUrl = '/' + url;
        console.log(this.share.lastUrl);
        // this.spinner.start();
        this.router.navigate(['/' + url]);
        // this.spinner.stopAll();
    }

    //---- @checkNotification ----
    //home و tableid/0 اگر در کنار لایسنس منوی آنلاین ، نسخه کلاینت اندروید در لایسنس موجود بود به جز صفحات 
    //اگر دیجیتال منو بود یا تبدیل منوی آنلاین به دیجیتال منو بود هم نمایش بده
    //تمامی میزها دارای فراخوانی گارسون خواهند بود.
    //-----
    checkNotification(x?: string): boolean {
        let systemLayer = this.share.setting.systemLayer;
        if (this.router.url == "/home") { this.hideNotification = true; return false; }
        if (this.router.url == "/table" || this.router.url == "/setting" || this.router.url == "/portal" || this.router.url == "/ordermanagement" || this.router.url == "/waiterorder") { this.hideNotification = true; return false; }
        
        if (this.share.tableId === '0' || this.router.url === "/order/TableId/0") {
            this.hideNotification = true;
            return false;
        }

        if (systemLayer.hasDigitalMenu || systemLayer.IsDigitalAlbumTransfer)
            this.hideNotification = false;

        if(systemLayer.isDigitalAlbum && systemLayer.hasTabletOrder === false)
            this.hideNotification = true;

        if (this.share.tableId === '0')
            this.hideNotification = true;
        else if (this.share.setting.systemLayer.isDigitalAlbum && this.share.setting.systemLayer.hasTabletOrder)
            this.hideNotification = false;

        if(systemLayer.isDigitalAlbum && systemLayer.hasTabletOrder)
            this.hideNotification = false;

        if (x == 'sidemenu' && this.hasPager && this.hideNotification)
            return true;
        if (this.hasPager && this.share.setting.systemLayer.hasDigitalMenu && this.share.tableId !== "0")
            return true;

        return true;
    }

    // isGarsonCall() {
    //     if (this.router.url == "/home") { return false; }

        
    //     let systemLayer = this.share.setting.systemLayer;
    //     if(systemLayer.hasTabletOrder)
    // }
}
